import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { inWhitelabel, getWhitelabelConfig } from 'core/whitelabel';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { Modal } from 'apps/modals/views/modal';

import CompactSignInForm from 'apps/signIn/views/CompactSignInForm';
// import { FablabsForm } from 'apps/signIn/views/fablabsForm';
import { WhiteLabelForm } from 'apps/signIn/views/whitelabelForm';
import { SingleOAuthForm } from 'apps/signIn/views/singleOAuthForm';
import { ResetPasswordModal } from 'apps/signIn/resetPassword/index';
import { conf as mainConf } from 'apps/config.yaml';

import { withNamespaces } from 'react-i18next';

import { ComponentRegistry } from 'core/registry';

const { siteName } = mainConf;

@withNamespaces()
@observer
class SignInModal extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = clientStore.context.get('signInAppManager');
    this.clickNoAccount = this.clickNoAccount.bind(this);
  }

  clickNoAccount() {
    // This prop indicates that we should swap to the signUpModal view
    // Instead of a boolean, signUpModal is the SignUpModal class as a
    // dependency injection to avoid circular dependencies.
    // There are better approaches to this.
    if (this.props.signUpModal) {
      modalStore.SetModalComponent(
        this.props.signUpModal,
        {},
        modalStore.onClose,
      );
    } else {
      clientStore.routerStore.navigate('home.signUp');
    }
  }

  clickForgotPassword() {
    modalStore.SetModalComponent(ResetPasswordModal);
  }

  render() {
    const { t } = this.props;
    const { form } = this.appManager.signInApp;
    let FormComponent = CompactSignInForm;
    if (inWhitelabel()) {
      if (getWhitelabelConfig().onlyOAuthSignIn) {
        FormComponent = SingleOAuthForm;
      } else {
        FormComponent = WhiteLabelForm;
      }
    }
    return (
      <FormComponent
        form={form}
        title={t('Log in to {{siteName}}', { siteName })}
        handleSignIn={this.appManager.signInApp.SignIn}
        handleNoAccount={this.clickNoAccount}
        handleForgotPassword={this.clickForgotPassword}
      />
    );
  }
}

ComponentRegistry.add('modals.SignInModal', SignInModal);

SignInModal.propTypes = {
  t: PropTypes.func,
};

export default SignInModal;
